import React from 'react';
import gql from 'graphql-tag';
import { RecommendationsPumoModuleFragment } from '../../generated/types/RecommendationsPumoModuleFragment';
import { Product } from '../../hooks/useRecommendations';
import { RecommendationsModule } from './RecommendationsModule';

export const RECOMMENDATIONS_PUMO_MODULE_FRAGMENT = gql`
  fragment RecommendationsPumoModuleFragment on RecommendationsPumoModule {
    layoutType
    dividerText
    dividerPadding
    affinityType
    algorithm
  }
`;

interface Props {
  recommendationsPumoModule: RecommendationsPumoModuleFragment;
  product?: Product | undefined;
}

export const RecommendationsPumoModule: React.FC<Props> = ({
  recommendationsPumoModule,
  product
}) => {
  const {
    layoutType,
    dividerText,
    dividerPadding,
    affinityType,
    algorithm
  } = recommendationsPumoModule;

  return (
    <RecommendationsModule
      algorithm={algorithm}
      affinityType={affinityType}
      product={product}
      divider={{ layoutType, text: dividerText, verticalPadding: dividerPadding }}
    />
  );
};
